import { render, staticRenderFns } from "./cognition_invite.vue?vue&type=template&id=48b18389&scoped=true"
import script from "./cognition_invite.vue?vue&type=script&lang=js"
export * from "./cognition_invite.vue?vue&type=script&lang=js"
import style0 from "./cognition_invite.vue?vue&type=style&index=0&id=48b18389&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b18389",
  null
  
)

export default component.exports